import React, { ReactElement } from 'react'
import { UiLayoutConstant } from '@/globals/uiLayoutConstant'
import styles from './Logo.module.less'
import { LogoProps } from '@/components/Logo/Logo.types'
import { useRouter } from 'next/router'

// The Just Enough Prep logo: owl mark + outlined Nunito wordmark in one SVG,
// so it renders identically everywhere with no font dependency. Same file
// family as the student site and the marketing assets (marketing/logo/final).
export const Logo: React.FC<LogoProps> = (): ReactElement => {
    const router = useRouter()
    return (
        <div
            className={`${styles.siteTitleContainer} ${styles.headerIcon}`}
            onClick={async (): Promise<void> => {
                await router.push({
                    pathname: UiLayoutConstant.PRIMARY_DASHBOARD_PAGE,
                })
            }}
        >
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
                className={styles.siteLogo}
                src={'/jepLogoShortDark.svg'}
                alt={'Just Enough Prep'}
                draggable={false}
            />
        </div>
    )
}
